import React from 'react'
import ProdIOOReqAddRow from './ProdIOOReqAddRow'
import FormDialog from '../../../../../library/form/components/FormDialog';
import FormROValue from '../../../../../library/form/components/FormROValue1';
import FormLabel from '../../../../../library/form/components/FormLabel';
import FormLink from '../../../../../library/form/components/FormLink';
import withView from '../../../../cmn/docAutomation/withView';
import SarasTrans from '../../../../../library/notifications/SarasTrans';
import { UiView, UiViewHeading, UiTitle, UiViewContent, UiRow, UiClear } from "../../../../../library/layout/Index";

const ProdIOOReqAdd = (props) => {
    const { formObject, viewData, ...restProps } = props;

    return (
        <>
            <FormDialog onDynamicViewClose={restProps.onDynamicViewClose} 
                enablePopup={true} formObject={formObject}
                action={{ formActions: { forAction: "Confirm", forCancel: "Cancel", confirmAction:"Are you sure to Confirm ?", confirmCancel:"Are you sure to Cancel ?" } }} 
                contentStyle={{ height: '350px' }}
                formStyle={{ width: '635px', height: '450px' }} formTitle={<SarasTrans value="Raise Stock Request" />}
            >
            <UiView>
                <UiRow>
                    <span className="uiLblS uiSpacerH5">
                        <FormLabel formObject={formObject} headerKey="prodHeaderRow" action={{ paramName: "itemId" }} value="Item ID" />:
                    </span>
                    <FormLink className="uiLink uiSpacerH15" formObject={formObject} headerKey="prodHeaderRow" linkProp={{ target: "_blank" }}
                        action={{ paramName: "itemId", actionId: "show", actionName: "itemComp" }}

                    />
                    <span className="uiLblS">
                        <FormLabel formObject={formObject} headerKey="prodHeaderRow" action={{ paramName: "itemName" }} value="Item Name" />:
                    </span>
                    <FormROValue formObject={formObject} headerKey="prodHeaderRow" action={{ paramName: "itemName" }} />
                </UiRow>
                <div className="uiSpacer10"></div>
                <UiClear></UiClear>
                <UiViewHeading>
                    <UiTitle>
                        <span className="uiInline">{<SarasTrans value="Materials" />}</span>
                    </UiTitle>
                </UiViewHeading>
                <UiViewContent>
                    <ul className="uiListTable">
                        <li className="uiSearchHeading">
                            <ul>
                                <li className="uiColumnCenter uiColumn50"><SarasTrans value="Sr" /></li>
                                <li className="uiColumnCenter uiColumn70"><SarasTrans value="Item Id" /></li>
                                <li className="uiColumnCenter uiColumn200"><SarasTrans value="Item Name" /></li>
                                <li className="uiColumnCenter uiColumn50"><SarasTrans value="Unit" /></li>
                                <li className="uiColumnCenter uiColumn70"><SarasTrans value="Req Qty 1" /> </li>
                                <li className="uiColumnCenter uiColumn70"><SarasTrans value="Req Qty 2" /> </li>
                            </ul>
                        </li>
                        {
                            Object.values(viewData ? viewData : {}).map((row, index) => (
                                <li><ProdIOOReqAddRow formObject={formObject} rowKey={row.rowKey} viewData={row} key={index} index={index + 1}/></li>
                            ))
                        }
                    </ul>
                </UiViewContent>
            </UiView>            
        </FormDialog>
        </>
    )
}

export default withView(ProdIOOReqAdd, "prodIOReq", "prodIOReq,prodIOSum");